{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "Buat tim baru",
    "HEADER": "Tim",
    "LOADING": "Fetching teams",
    "DESCRIPTION": "Teams allow you to organize agents into groups based on their responsibilities. An agent can belong to multiple teams. When working collaboratively, you can assign conversations to specific teams.",
    "LEARN_MORE": "Learn more about teams",
    "COUNT": "{n} team | {n} teams",
    "SEARCH_PLACEHOLDER": "Mencari tim...",
    "NO_RESULTS": "No teams found matching your search",
    "LIST": {
      "404": "Belum ada tim yang dibuat pada akun ini.",
      "EDIT_TEAM": "Edit Tim",
      "NONE": "Tidak ada"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "Buat tim",
        "DESC": "Tambahkan judul dan deskripsi untuk tim baru Anda."
      },
      "AGENTS": {
        "BUTTON_TEXT": "Tambahkan agen ke tim Anda",
        "TITLE": "Tambahkan agen ke tim - {teamName}",
        "DESC": "Tambahkan agen pada tim baru Anda. Ini memungkinkan Anda berkolaborasi sebagai sebuah tim pada percakapan, mendapatkan notifikasi atas peristiwa baru dalam percakapan yang sama."
      },
      "WIZARD_CREATE": {
        "TITLE": "Buat",
        "BODY": "Buat tim baru dari agen-agen."
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "Tambahkan Agen",
        "BODY": "Tambahkan agen-agen ke dalam tim."
      },
      "WIZARD_FINISH": {
        "TITLE": "Selesai",
        "BODY": "Sekarang kotak masuk Anda sudah siap!"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "Edit detil tim Anda",
        "DESC": "Edit judul dan deskripsi tim Anda.",
        "BUTTON_TEXT": "Update tim"
      },
      "AGENTS": {
        "BUTTON_TEXT": "Update agen dalam tim",
        "TITLE": "Tambahkan agen ke tim - {teamName}",
        "DESC": "Tambahkan agen-agen pada tim baru Anda. Semua agen yang telah ditambahkan akan mendapatkan notifikasi ketika sebuah percakapan dialokasikan pada tim ini."
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "Detil tim",
        "ROUTE": "pengaturan_tim_edit",
        "BODY": "Ubah nama, deskripsi, dan detil lainnya."
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "Edit Agen",
        "ROUTE": "pengaturan_tim_edit_anggota",
        "BODY": "Edit agen-agen dalam tim Anda."
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "Selesai",
        "ROUTE": "pengaturan_tim_edit_selesai",
        "BODY": "Sekarang kotak masuk Anda sudah siap!"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "Tidak dapat menyimpan detil tim. Coba lagi."
    },
    "AGENTS": {
      "AGENT": "Agen",
      "EMAIL": "Email",
      "BUTTON_TEXT": "Tambahkan Agen",
      "ADD_AGENTS": "Menambahkan Agen ke Tim Anda...",
      "SELECT": "pilih",
      "SELECT_ALL": "pilih semua agen",
      "SELECTED_COUNT": "{selected} dari {total} agen terpilih."
    },
    "ADD": {
      "TITLE": "Tambahkan agen ke tim - {teamName}",
      "DESC": "Tambahkan agen-agen pada tim baru Anda. Ini memungkinkan Anda berkolaborasi sebagai sebuah tim pada percakapan, mendapatkan notifikasi atas peristiwa baru dalam percakapan yang sama.",
      "SELECT": "pilih",
      "SELECT_ALL": "pilih semua agen",
      "SELECTED_COUNT": "{selected} dari {total} agen terpilih.",
      "BUTTON_TEXT": "Tambahkan Agen",
      "AGENT_VALIDATION_ERROR": "Pilih setidaknya satu agen."
    },
    "FINISH": {
      "TITLE": "Tim Anda siap!",
      "MESSAGE": "Sekarang Anda dapat berkolaborasi sebagai sebuah tim pada percakapan. Selamat mendukung ",
      "BUTTON_TEXT": "Selesai"
    },
    "DELETE": {
      "BUTTON_TEXT": "Hapus",
      "API": {
        "SUCCESS_MESSAGE": "Tim berhasil dihapus.",
        "ERROR_MESSAGE": "Tidak dapat menghapus tim. Coba lagi."
      },
      "CONFIRM": {
        "TITLE": "Are you sure you want to delete the team?",
        "PLACE_HOLDER": "Silakan ketik {teamName} untuk konfirmasi",
        "MESSAGE": "Menghapus tim akan menghilangkan alokasi tim dari percakapan yang telah ditetapkan terhadap tim ini.",
        "YES": "Hapus ",
        "NO": "Batalkan"
      }
    },
    "SETTINGS": "Pengaturan",
    "FORM": {
      "UPDATE": "Update tim",
      "CREATE": "Buat tim",
      "NAME": {
        "LABEL": "Nama Tim",
        "PLACEHOLDER": "Contoh: Sales, Customer Support"
      },
      "DESCRIPTION": {
        "LABEL": "Deskripsi Tim",
        "PLACEHOLDER": "Deskripsi singkat tentang tim ini."
      },
      "AUTO_ASSIGN": {
        "LABEL": "Izinkan penugasan otomatis untuk tim ini."
      },
      "SUBMIT_CREATE": "Buat tim"
    }
  }
}
